import { guideMemory } from './guide-memory'
import { getMe } from './me'
import { el } from './ui'
import './onboarding.css'

// Today's first-time hint for the round tick (Liam's pick A plus the hint, 27 Oct 2026, of
// https://claude.ai/artifact/2NUWVZAJQoS4KQHguDksjH: "it's not immediately obvious that you need to touch the [tick] to
// mark it done"). In the shared guidance style (docs/ANIMATION-STANDARD.md): the open job's tick pulses twice, keeps a
// quiet lemon outline, and a pale-yellow tip under the job's address says what it does. It goes for good on this
// phone, for this person and round, once they tap any tick or Got it. Nothing is ever marked done for them.

const STEP = 'today-done-tick'
// The two pulses play once a visit, not on every redraw of the day (the standard: no replay on ordinary redraws).
let pulsed = false

function memory(): ReturnType<typeof guideMemory> | null {
  const me = getMe()
  if (!me?.businessId || !me.email) return null
  return guideMemory(`${me.businessId}:${me.email}`, () => localStorage)
}

// After the day is drawn: the hint on the open job, if this person has not learnt the tick yet.
export function mountTodayDoneHint(day: HTMLElement): void {
  const mem = memory()
  if (!mem || mem.seen(STEP)) return
  // Any tick learnt it (pressed before the tip's own handler, on every job).
  for (const t of day.querySelectorAll<HTMLButtonElement>('.stop-tick')) t.addEventListener('click', () => mem.complete(STEP), { once: true })
  const stop = day.querySelector<HTMLElement>('.today-stops > .today-stop.is-open:not(.today-done):not(.today-live)')
  const tick = stop?.querySelector<HTMLButtonElement>(':scope > .stop-tick')
  if (!stop || !tick) return
  tick.classList.add('onboarding-target')
  if (!pulsed) { pulsed = true; tick.classList.add('onboarding-pulse') }
  const got = el('button', { type: 'button', class: 'link-button' }, 'Got it')
  const tip = el('aside', { class: 'onboarding-hint today-done-hint', id: 'today-done-hint', 'aria-label': 'Today tip' },
    el('p', {}, el('strong', {}, 'Finished? Tap Done'), ', the tick at the top right. It marks the job done and opens the next one. You can Undo.'),
    el('div', { class: 'onboarding-hint-actions' }, got))
  got.addEventListener('click', () => {
    mem.complete(STEP)
    tick.classList.remove('onboarding-target', 'onboarding-pulse')
    tip.remove()
    tick.focus({ preventScroll: true })
  })
  tick.setAttribute('aria-describedby', 'today-done-hint')
  // Under the address, before the job's buttons: near the work, nothing above it moves.
  const actions = stop.querySelector<HTMLElement>(':scope > .stop-actions')
  if (actions) actions.before(tip); else stop.append(tip)
}
